var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schedules_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,44.5H5.1c-3,0-5.4-2.4-5.4-5.4V12.3c0-3,2.4-5.4,5.4-5.4h25.1c3,0,5.4,2.4,5.4,5.4V23 c0,0.9-0.7,1.7-1.6,1.8c-4.1,0.4-7.3,3.9-7.3,8c0,3.6,2.3,6.7,5.8,7.7c0.7,0.2,1.2,0.8,1.3,1.5c0.1,0.7-0.3,1.4-1,1.8 C31.9,44.3,31,44.5,30.2,44.5z M5.1,10.5c-1,0-1.8,0.8-1.8,1.8v26.9c0,1,0.8,1.8,1.8,1.8h21.2c-2-2.1-3.2-5-3.2-8.1 c0-5.4,3.8-10.1,9-11.3v-9.3c0-1-0.8-1.8-1.8-1.8H5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,12.6c-1,0-1.8-0.8-1.8-1.8V3.3c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v7.5C11.5,11.8,10.7,12.6,9.8,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,12.6c-1,0-1.8-0.8-1.8-1.8V3.3c0-1,0.8-1.8,1.8-1.8S28,2.3,28,3.3v7.5C28,11.8,27.2,12.6,26.3,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,19.8H2.4c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h31.2c1,0,1.8,0.8,1.8,1.8 C35.4,19,34.6,19.8,33.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,44.5c-6.4,0-11.6-5.2-11.6-11.6s5.2-11.6,11.6-11.6s11.6,5.2,11.6,11.6S41.1,44.5,34.6,44.5z M34.6,24.8 c-4.4,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1S39.1,24.8,34.6,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,34.7h-2.1c-1,0-1.8-0.8-1.8-1.8v-4.1c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8v2.3h0.3 c1,0,1.8,0.8,1.8,1.8C38.6,33.9,37.8,34.7,36.8,34.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedules);
export default __webpack_public_path__ + "static/media/Schedules.4fa187a19c81e66f216f92961d9e765a.svg";
export { ForwardRef as ReactComponent };